import { render } from "./figthRules.vue?vue&type=template&id=49344e10&scoped=true"
import script from "./figthRules.vue?vue&type=script&lang=js"
export * from "./figthRules.vue?vue&type=script&lang=js"

import "./figthRules.vue?vue&type=style&index=0&id=49344e10&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49344e10"]])

export default __exports__